// export const GOOGLE_KEY = "AIzaSyDCs4nW7KM6puPvZdcaMrjcFDX_Wk53XCk";
export const GOOGLE_KEY = "AIzaSyCvM1-e4h62jueZ0wc-yKKhPzCVzxyge0U"; // used mobile app google map key

export const LIBRARIES = ["places", "routes"];
